var map = {
	"./boarsIncrease.png": 42878,
	"./chooseIcon.png": 43762,
	"./circle.png": 99448,
	"./closeView.png": 6723,
	"./dataStream2.gif": 30806,
	"./detailNoData.png": 4485,
	"./detailOccupancy.png": 53851,
	"./eyeView.png": 47728,
	"./getOff.png": 31746,
	"./girl.png": 23507,
	"./greenTick.png": 13811,
	"./guideHomebg1.png": 74170,
	"./guideHomebg2.png": 18086,
	"./lamp.png": 1288,
	"./lampHover.png": 3747,
	"./langActBtn.png": 53244,
	"./langBtn.png": 91428,
	"./linkTo.png": 3651,
	"./mainLeft.png": 36874,
	"./mainLeft1.png": 31350,
	"./mainLogo.png": 60495,
	"./man.png": 29049,
	"./man1.png": 21182,
	"./material1.png": 5393,
	"./material2.png": 82244,
	"./material3.png": 77729,
	"./material4.png": 73903,
	"./material5.png": 64340,
	"./menuIcon.png": 56700,
	"./nineIcon.png": 33364,
	"./paperInset.png": 31165,
	"./paperLogo.png": 24018,
	"./paperLogo1.png": 11368,
	"./pay/Bancontact.png": 55178,
	"./pay/Link1.png": 17773,
	"./pay/affirm.png": 44749,
	"./pay/alipay.png": 42309,
	"./pay/amazonPay.png": 98212,
	"./pay/applePay.png": 55161,
	"./pay/card.png": 69542,
	"./pay/cashAppPay.png": 33240,
	"./pay/googlePay.png": 13700,
	"./pay/klarna.png": 51337,
	"./pay/link.png": 38427,
	"./pay/wechat.png": 70376,
	"./people.png": 28022,
	"./priceIcon0.png": 25224,
	"./priceIcon1.png": 58703,
	"./priceIcon2.png": 24691,
	"./priceIcon3.png": 99818,
	"./priceIcon4.png": 39409,
	"./priceIcon5.png": 64346,
	"./registerRight.png": 65028,
	"./school1.png": 91782,
	"./school10.png": 82662,
	"./school11.png": 44828,
	"./school12.png": 16886,
	"./school13.png": 66526,
	"./school14.png": 10433,
	"./school15.png": 30969,
	"./school16.png": 1320,
	"./school17.png": 13975,
	"./school18.png": 58590,
	"./school19.png": 11506,
	"./school2.png": 6382,
	"./school20.png": 5372,
	"./school3.png": 63001,
	"./school4.png": 33564,
	"./school5.png": 40196,
	"./school6.png": 7647,
	"./school7.png": 32821,
	"./school8.png": 97793,
	"./school9.png": 57985,
	"./seo.gif": 77145,
	"./service001.jpeg": 29709,
	"./service002.jpeg": 22453,
	"./service003.jpeg": 44948,
	"./service004.jpeg": 85553,
	"./service005.jpeg": 87556,
	"./sevenImg.png": 60733,
	"./statusFour.png": 83896,
	"./statusThree.png": 76663,
	"./statusThree1.png": 54749,
	"./statusTwo.png": 76529,
	"./statusTwo1.png": 67619,
	"./template1.png": 55541,
	"./template2.png": 43687,
	"./thesis.png": 76780,
	"./thirdImg.png": 4315,
	"./thirdPart.png": 9595,
	"./toTopBtn.png": 25907,
	"./yellowTick.png": 88610,
	"./yinhao.png": 40511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79277;